export default {
  "首页": "Ana Sayfa",
  "订单": "Sipariş",
  "新闻": "Haberler",
  "个人中心": "Kişisel Merkez",
  "模拟账户": "Simülasyon Hesabı",
  "可用资产": "Kullanılabilir Varlıklar",
  "入金": "Para Yatırma",
  "出金": "Para Çekme",
  "账单详情": "Fatura Detayları",
  "重置模拟账户": "Simülasyon Hesabını Sıfırla",
  "钱包": "Cüzdan",
  "实名认证": "Kimlik Doğrulama",
  "邀请好友": "Arkadaşları Davet Et",
  "修改密码": "Şifreyi Değiştir",
  "投诉邮箱": "Şikayet E-Postası",
  "其它": "Diğer",
  "公告": "Duyurular",
  "语言": "Dil",
  "是否退出登录": "Çıkış yapmak istediğinizden emin misiniz?",
  "复制": "Kopyala",
  "复制成功": "Başarıyla Kopyalandı",
  "发送验证码成功": "Doğrulama Kodu Gönderildi",
  "请输入密码": "Lütfen şifrenizi girin",
  "请再次输入密码": "Lütfen şifrenizi tekrar girin",
  "复制邀请链接": "Davet Linkini Kopyala",
  "上传身份": "Kimlik / Pasaport ön ve arka tarafını yükleyin",
  "正面": "Ön Taraf",
  "上传正面": "Kimlik / Pasaport Önünü Yükleyin",
  "反面": "Arka Taraf",
  "上传反面": "Kimlik / Pasaport Arka Tarafını Yükleyin",
  "完善信息": "Lütfen kişisel bilgilerinizi tamamlayın",
  "输入姓名": "Adınızı girin",
  "身份证号": "Pasaport / Kimlik Numarası",
  "输入身份证号": "Pasaport / Kimlik Numaranızı Girin",
  "收款货币": "Alınacak Para Birimi",
  "银行名称": "Banka Adı",
  "收款人账户": "Alıcı Hesabı",
  "货币": "Para Birimi",
  "分店名称": "Şube Adı",
  "绑定银行卡": "Banka Kartınızı Bağlayın",
  "银行地址": "Banka Adresi",
  "账号名称（假名）": "Hesap Adı (Takma Ad)",
  "绑定数字货币地址": "Dijital Para Cüzdanı Adresi Bağlayın",
  "余额": "Bakiye",
  "联系客服": "Müşteri Hizmetleri ile İletişime Geç",
  "行情": "Piyasalar",
  "其他": "Diğer",
  "设置": "Ayarlar",
  "收款人": "Alıcı",
  "添加": "Ekle",
  "确认": "Onayla",
  "取消": "İptal Et",
  "钱包地址": "Cüzdan Adresi",
  "请输入": "Lütfen girin",
  "退出登录": "Çıkış Yap",
  "充值数量": "Yatırılacak Miktar",
  "提交": "Gönder",
  "银行卡": "Banka Kartı",
  "选择网络": "Ağ Seçin",
  "数字货币": "Dijital Para",
  "上传验证": "Doğrulama Yükle",
  "提币地址": "Çekim Adresi",
  "数量(USD)": "Miktar (USD)",
  "备注": "Açıklama",
  "手续费": "İşlem Ücreti",
  "预计到账数量": "Tahmini Alınacak Miktar",
  "暂无数据": "Veri Yok",
  "入金记录": "Yatırma Kayıtları",
  "提币记录": "Çekim Kayıtları",
  "验证码": "Doğrulama Kodu",
  "邀请码": "Davet Kodu",
  "提示": "İpucu",
  "请输入验证码": "Lütfen doğrulama kodunu girin",
  "姓名": "Ad",
  "邮箱登录": "E-posta ile giriş yap",
  "邮箱": "E-posta",
  "密码": "Şifre",
  "新用户": "Yeni Kullanıcı",
  "立即加入": "Hemen Katıl",
  "忘记密码": "Şifremi Unuttum",
  "登录": "Giriş Yap",
  "无需开户,立即创建模拟账号进行交易!": "Hesap açmaya gerek yok, hemen simülasyon hesabı oluşturup işlem yapmaya başlayın!",
  "电话": "Telefon",
  "再次输入密码": "Şifrenizi tekrar girin",
  "职业": "Meslek",
  "年收入": "Yıllık Gelir",
  "注册": "Kayıt Ol",
  "邮箱注册": "E-posta ile Kayıt Ol",
  "发送": "Gönder",
  "重置密码": "Şifreyi Sıfırla",
  "是否重置": "Şifreyi sıfırlamak istediğinizden emin misiniz?",
  "已重置": "Şifre Sıfırlandı",
  "名称": "İsim",
  "注册成功": "Kayıt Başarılı",
  "加载中": "Yükleniyor",
  "您还未登录，请先登录": "Henüz giriş yapmadınız, lütfen önce giriş yapın",
  "退出成功": "Başarıyla Çıkış Yapıldı",
  "市价": "Piyasa Fiyatı",
  "挂单": "Bekleyen Sipariş",
  "倍数": "Çarpan",
  "止盈": "Kar Al",
  "止损": "Zarar Durdur",
  "买入数量": "Alınacak Miktar",
  "每手": "Her İşlemde",
  "预估手续费": "Tahmini İşlem Ücreti",
  "预估保证金": "Tahmini Teminat",
  "买入": "Al",
  "卖出": "Sat",
  "您的订单已确认": "Siparişiniz Onaylandı",
  "订单页面": "Sipariş Sayfası",
  "盈亏": "Kar/Zarar",
  "当前保证金": "Mevcut Teminat",
  "订单详情": "Sipariş Detayları",
  "保证金": "Teminat",
  "平仓": "Pozisyon Kapat",
  "修改": "Değiştir",
  "手数": "Lot Sayısı",
  "暂无数据": "Veri Yok",
  "历史": "Geçmiş",
  "价格": "Fiyat",
  "请输入价格": "Fiyatı girin",
  "手": "Lot",
  "搜索结果": "Arama Sonuçları",
  "搜索产品": "Ürün Ara",
  "持仓": "Pozisyon",
  "语言": "Dil",
  "审核中": "İnceleniyor",
  "请上传证件照正/反面": "Lütfen kimlik / pasaport ön ve arka tarafını yükleyin",
  "上传成功": "Başarıyla Yüklendi",
  "上传失败": "Yükleme Başarısız",
  "提交成功": "Başarıyla Gönderildi",
  "删除": "Sil",
  "删除成功": "Başarıyla Silindi",
  "提币": "Para Çek",
  "缺少参数或传值错误": "Eksik parametre veya yanlış değer gönderildi",
  "操作成功": "İşlem Başarılı",
  "充值金额": "Yatırılan Miktar",
  "类型": "Tür",
  "状态": "Durum",
  "时间": "Zaman",
  "单位": "Birim",
  "最高价": "En Yüksek Fiyat",
  "最低价": "En Düşük Fiyat",
  "开盘价": "Açılış Fiyatı",
  "请注册或登录真实账号": "Lütfen gerçek bir hesap kaydedin veya giriş yapın",
  "没有更多了": "Daha fazla veri yok",
  "提现金额": "Çekilen Miktar",
  "审核通过": "Onaylandı",
  "审核不通过": "Onaylanmadı",
  "重新提交": "Yeniden Gönder",
  "止盈价": "Kar Al Fiyatı",
  "止损价": "Zarar Durdurma Fiyatı",
  "总盈亏": "Toplam Kar/Zarar",
  "撤单": "Siparişi İptal Et",
  "请先进行实名认证": "Lütfen önce kimlik doğrulaması yapın",
  "产品列表": "Ürün Listesi",
  "下单": "Sipariş Ver",
  "可用资金": "Kullanılabilir Fonlar",
  "欢迎登录": "Hoşgeldiniz",
  "可用": "Kullanılabilir",
  "冻结": "Donmuş",
  "财务记录": "Finansal Kayıtlar",
  "交易对": "Ticaret Çifti",
  "开仓时间": "Pozisyon Açılış Zamanı",
  "收益": "Kar",
  "操作": "İşlem",
  "下单价": "Sipariş Fiyatı",
  "当前价": "Mevcut Fiyat",
  "订单号": "Sipariş Numarası",
  "请选择": "Lütfen seç",
  "卖出(做空)止损价不能低于开仓价": "Satış (Short) Zarar Durdurma Fiyatı Açılış Fiyatından Düşük Olamaz",
  "卖出(做多)止盈价不能高于开仓价": "Satış (Long) Kar Al Fiyatı Açılış Fiyatından Yüksek Olamaz",
  "买入(做多)止损价不能高于开仓价": "Alış (Long) Zarar Durdurma Fiyatı Açılış Fiyatından Yüksek Olamaz",
  "买入(做多)止盈价不能低于开仓价": "Alış (Long) Kar Al Fiyatı Açılış Fiyatından Düşük Olamaz",
  "买入(做多)止盈价不能低于开仓价和现价": "Alış (Long) Kar Al Fiyatı Açılış Fiyatı ve Mevcut Fiyatın Altında Olamaz",
  "买入(做多)止损价不能高于开仓价和现价": "Alış (Long) Zarar Durdurma Fiyatı Açılış Fiyatı ve Mevcut Fiyatın Üstünde Olamaz",
  "卖出(做空)止损价不能低于开仓价和现价": "Satış (Short) Zarar Durdurma Fiyatı Açılış Fiyatı ve Mevcut Fiyatın Altında Olamaz",
  "卖出(做多)止盈价不能高于开仓价和现价": "Satış (Long) Kar Al Fiyatı Açılış Fiyatı ve Mevcut Fiyatın Üstünde Olamaz",

  "提现手续费": "Gönderme ücreti",
  "提现退回": "Kaçırma ödemesi",
  "系统加款": "Sistem ekle",
  "系统减款": "Sistem düşürmesi",

  "交易周期": "İşlem döngüsü",
  "秒": "Saniye",
  "交易额": "İşlem tutarı",
  "买涨": "Fiyatın yükselmesini bekleyerek almak",
  "买跌": "Fiyatın düşmesini bekleyerek almak",
  "秒数": "Saniye sayısı",
  "交易类型": "İşlem türü",
  "看涨": "Fiyatın yükselmesini beklemek",
  "看跌": "Fiyatın düşmesini beklemek",
  "剩余时间": "Kalan süre",
  "买入价": "Alış fiyatı",
  "结算价": "Ödeme fiyatı",
  "交易额": "İşlem tutarı",
  "下单时间": "Sipariş zamanı",
  "结算时间": "Ödeme zamanı",
  "该币种暂无交易": "Şu anda bu para için bir transaksyon yok",

  "总资产": "Toplam Sermaye",
  "币种": "Para Birimi",
  "资产折合": "Sermaye Dönüşümü",
  "冻结金额": "Dondurulmuş Tutar",
  "可用金额": "Kullanılabilir Tutar",
  "公司资产": "Şirket Sermayesi",
  "请输入旧密码": "Lütfen eski parolayı girin",
  "请输入新密码": "Lütfen yeni parolayı girin",
  "请再次输入新密码": "Lütfen yeni parolayı tekrar girin",
  "白皮书": "Beyaz Defter",
  "注册证书": "Kayıt Belgesi",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "Yukarıda verilen bilgilerin son yorum hakkı resmen aittir.",
  "上一页": "Önceki Sayfa",
  "下一页": "Sonraki Sayfa",
  "关闭": "Kapat",
  "闪电兑换": "Şimşek Dönüşümü",
  "全部": "Hepsi",
  "可用余额": "Kullanılabilir Bakiye",
  "到": "Doğru",
  "请输入数量": "Lütfen miktarı girin",
  "币种选择": "Para Birimi Seçimi",
  "从": "İle",
  "兑换": "Dönüştür",
  "兑换成功！": "Dönüşüm Başarılı!",
  "支付": "Ödeme",
  "全部兑换成功": "Tüm dönüşümler başarılı oldu",
  "获取": "Al",
  "数量": "miktar",
  "拒绝原因": "Sebebini reddedin",
  "交易密码": "İşlem şifresi",
  "设置交易密码": "İşlem şifresini ayarla",
  "重置交易密码": "İşlem şifresini sıfırla",
  "确定": "Onayla",
  "是否购买？": "Satın al?",
  "外汇": "Döviz",
  "期权": "Opsiyon",
  "(用户中心)": "(Kullanıcı Merkezi)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "İşleminiz gerçekleştiriliyor, lütfen diğer işlemleri yapmadan önce işleminizin tamamlanmasını sabırla bekleyin!",
  "继续下单": "Siparişi devam ettir",
  "交易方向": "Ticaret Yönü",
  "实现盈利": "Kar sağlamak",
  "最新价格": "Son fiyat",
  "结算完成": "Ödeme tamamlandı",
  "下单余额不足": "Sipariş vermek için yetersiz bakiye",
  "输入交易额度": "İşlem tutarını girin",
  "选择交易周期": "Ticaret süresi seçin",
  "审核拒绝": "İnceleme reddedildi",
  "请输入正确的数量!": "Lütfen doğru miktarı girin!",
  "上传身份": "Kimlik yükle",
  "上传正面": "Ön yüzü yükle",
  "上传反面": "Arka yüzü yükle",
  "完善信息": "Bilgileri tamamla",
  "输入姓名": "Adınızı girin",
  "输入身份证号": "Kimlik numarasını girin",
  "身份证号": "Kimlik numarası",
  "请上传证件照正/反面": "Lütfen kimlik belgesinin ön/arka yüzünü yükleyin",
  "最小提现金额10USDT": "Minimum çekim miktarı 10 USDT'dir",
  "证件号码": "Kimlik Numarası",
  "输入证件号码": "Kimlik Numarasını Girin",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "Kimlik doğrulaması için kimlik kartınızı, ehliyetinizi veya pasaportunuzu yükleyin!"


}
